import axios from 'axios'

const ActivityLogService = {
  async getList (params = {}) {
    return axios.get('admin/activity-logs', { params })
  },

  async getFilterOptions () {
    return axios.get('admin/activity-logs/filter-options')
  }
}

export default ActivityLogService
